import React from 'react'
import { Typography, Divider } from 'antd'

const { Title, Paragraph, Text } = Typography

const TermsAndServicesPage = () => (
   <div style={{ maxWidth: 1200, margin: '0 auto', padding: 24 }}>
      <Typography>
         <Title level={2}>Điều Khoản và Dịch Vụ</Title>

         <Paragraph>
            Chào mừng bạn đến với ứng dụng <Text strong>Xe ghép Thanh Hóa – Hà Nội</Text> (
            <a href="https://xegheplinhlinh36.com" target="_blank" rel="noreferrer">
               xegheplinhlinh36.com
            </a>
            ).
         </Paragraph>

         <Paragraph>
            Ứng dụng <Text strong>Xe ghép Thanh Hóa – Hà Nội</Text> là nền tảng công nghệ trung gian, giúp kết nối{' '}
            <Text strong>tài xế</Text> và <Text strong>hành khách</Text> có nhu cầu di chuyển cùng tuyến đường nhằm chia
            sẻ chi phí đi lại.
         </Paragraph>

         <Paragraph>
            Các điều khoản và dịch vụ này (“Điều khoản”) quy định quyền, nghĩa vụ và trách nhiệm của người dùng khi truy
            cập, cài đặt và sử dụng ứng dụng.
         </Paragraph>

         <Paragraph>
            Việc bạn cài đặt, truy cập hoặc sử dụng ứng dụng đồng nghĩa với việc bạn đã đọc, hiểu và đồng ý bị ràng buộc
            bởi toàn bộ nội dung Điều khoản này. Nếu bạn không đồng ý với bất kỳ nội dung nào, vui lòng ngừng sử dụng
            ứng dụng.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>1. Phạm vi dịch vụ</Title>

         <Paragraph>Ứng dụng cung cấp nền tảng để:</Paragraph>

         <ul>
            <li>Kết nối tài xế và hành khách có nhu cầu đi chung tuyến</li>
            <li>Hiển thị thông tin chuyến đi do tài xế đăng tải</li>
            <li>Hỗ trợ liên lạc giữa các bên liên quan</li>
         </ul>

         <Paragraph>
            Ứng dụng <Text strong>không phải</Text> là đơn vị kinh doanh vận tải, không trực tiếp cung cấp dịch vụ vận
            chuyển và không tham gia vào việc thu – chi tiền giữa tài xế và hành khách.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>2. Tài khoản và thông tin người dùng</Title>

         <Paragraph>Khi sử dụng ứng dụng, bạn cam kết:</Paragraph>

         <ul>
            <li>Cung cấp thông tin chính xác, đầy đủ và cập nhật</li>
            <li>Không mạo danh, sử dụng thông tin của người khác</li>
            <li>Tự bảo mật thông tin tài khoản và thiết bị truy cập</li>
         </ul>

         <Paragraph>
            Bạn hoàn toàn chịu trách nhiệm đối với mọi hoạt động được thực hiện thông qua tài khoản của mình, kể cả
            trong trường hợp tài khoản bị người khác sử dụng trái phép do lỗi từ phía bạn.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>3. Thu thập và sử dụng dữ liệu</Title>

         <Paragraph>
            Ứng dụng có thể thu thập một số thông tin cần thiết để vận hành và cải thiện trải nghiệm người dùng, bao gồm
            nhưng không giới hạn:
         </Paragraph>

         <ul>
            <li>Thông tin thiết bị (loại thiết bị, hệ điều hành)</li>
            <li>Thông tin do người dùng chủ động cung cấp</li>
         </ul>

         <Paragraph>Chúng tôi cam kết:</Paragraph>

         <ul>
            <li>Chỉ sử dụng dữ liệu cho mục đích vận hành và cải thiện dịch vụ</li>
            <li>Không mua bán, trao đổi dữ liệu cá nhân trái phép</li>
            <li>Bảo mật thông tin theo quy định pháp luật hiện hành</li>
         </ul>

         <Divider />

         {/* ===================== */}
         <Title level={4}>4. Nghĩa vụ và hành vi bị cấm</Title>

         <Paragraph>
            Khi sử dụng ứng dụng, người dùng <Text strong>không được</Text>:
         </Paragraph>

         <ul>
            <li>Sử dụng ứng dụng cho mục đích trái pháp luật</li>
            <li>Đăng tải thông tin sai sự thật, gây nhầm lẫn</li>
            <li>Gây rối, quấy rối, đe dọa hoặc xúc phạm người dùng khác</li>
            <li>Khai thác, can thiệp trái phép vào hệ thống ứng dụng</li>
         </ul>

         <Divider />

         {/* ===================== */}
         <Title level={4}>5. Nội dung do người dùng cung cấp</Title>

         <Paragraph>
            Người dùng chịu hoàn toàn trách nhiệm đối với mọi nội dung, thông tin, hình ảnh hoặc phản hồi do mình cung
            cấp trên ứng dụng.
         </Paragraph>

         <Paragraph>
            <Text strong>Xe ghép Thanh Hóa – Hà Nội</Text> có quyền xem xét, từ chối, chỉnh sửa hoặc xóa bất kỳ nội dung
            nào vi phạm pháp luật, thuần phong mỹ tục hoặc Điều khoản này mà không cần thông báo trước.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>6. Thanh toán và chi phí</Title>

         <Paragraph>
            Mọi thỏa thuận chi phí chuyến đi được thực hiện trực tiếp giữa tài xế và hành khách. Ứng dụng hiện tại không
            hỗ trợ thanh toán trực tuyến và không thu bất kỳ khoản phí nào từ người dùng.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>7. Quyền sở hữu trí tuệ</Title>

         <Paragraph>
            Toàn bộ nội dung, giao diện, logo, thiết kế và mã nguồn của ứng dụng thuộc quyền sở hữu hợp pháp của{' '}
            <Text strong>xegheplinhlinh36.com</Text>.
         </Paragraph>

         <Paragraph>
            Nghiêm cấm mọi hành vi sao chép, chỉnh sửa, phân phối hoặc khai thác cho mục đích thương mại khi chưa có sự
            chấp thuận bằng văn bản.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>8. Giới hạn trách nhiệm</Title>

         <Paragraph>
            Trong phạm vi pháp luật cho phép, chúng tôi không chịu trách nhiệm đối với các thiệt hại phát sinh do:
         </Paragraph>

         <ul>
            <li>Sự cố kỹ thuật, gián đoạn hệ thống</li>
            <li>Hành vi, thỏa thuận hoặc tranh chấp giữa người dùng với nhau</li>
            <li>Thông tin do người dùng cung cấp không chính xác</li>
            <li>Sự kiện bất khả kháng ngoài tầm kiểm soát</li>
         </ul>

         <Divider />

         {/* ===================== */}
         <Title level={4}>9. Thay đổi điều khoản</Title>

         <Paragraph>
            Chúng tôi có quyền sửa đổi, bổ sung Điều khoản này bất kỳ lúc nào để phù hợp với quy định pháp luật và định
            hướng phát triển ứng dụng.
         </Paragraph>

         <Paragraph>
            Phiên bản cập nhật sẽ được công bố trên ứng dụng và có hiệu lực ngay khi đăng tải. Việc bạn tiếp tục sử dụng
            ứng dụng đồng nghĩa với việc bạn chấp nhận các thay đổi đó.
         </Paragraph>

         <Divider />

         {/* ===================== */}
         <Title level={4}>10. Chấm dứt sử dụng</Title>

         <Paragraph>
            Chúng tôi có quyền tạm ngừng hoặc chấm dứt quyền truy cập của người dùng nếu phát hiện hành vi vi phạm Điều
            khoản hoặc pháp luật hiện hành.
         </Paragraph>

         <Divider />

         <Paragraph type="secondary">
            Điều khoản này có hiệu lực kể từ thời điểm người dùng cài đặt và sử dụng ứng dụng.
         </Paragraph>
      </Typography>
   </div>
)

export default TermsAndServicesPage
